<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-16 13:10:39
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-29 15:10:59
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/component-cyhjts.vue
 * @Description: 描述
-->
<template>
  <div class="cyhjts">
    <div class="content">
      <div class="subtitle">茶园物联</div>
      <component-cywl style="margin-bottom: 15px" />
      <component-tqtr />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.cyhjts {
  padding-top: 52px;
  .content {
    padding: 10px 25px;
    height: 100%;
    position: relative;
    .subtitle {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.8;
      .unselect {
        color: #ffffff;
        opacity: 0.45;
      }
    }
  }
}
</style>
